/**
 * @file Account related fragments.
 */

import gql from 'graphql-tag';

export const UserDetails = gql`
  fragment UserDetails on Account {
    id
    email_address
    username
    name
    phone_number
    organization_name
    slug
    created_at
  }
`;
